import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ShipmentUnLoadingForm from "./ShipmentUnLoadingComponents/ShipmentUnLoadingForm";

import { useGetShipmentUnLoadingDetailQuery, useUpdateShipmentUnLoadingMutation } from "store/services/shipmentUnLoadingApi";

import { useAppMeta } from "hooks";

const ShipmentUnLoadingEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment Unloading", path: "/app/crm/shipment-unLoading/list" },
    { title: "Edit Shipment Unloading" },
  ];

  // RTK Query
  const { data: shipmentUnLoadingDetail, isLoading: loadingShipmentUnLoading, error,
  } = useGetShipmentUnLoadingDetailQuery(id)

  const [updateShipmentUnLoading, { isLoading: updatingShipmentUnLoading }
  ] = useUpdateShipmentUnLoadingMutation();

  // methods
  const handleUpdateShipmentUnLoading = async (data) => {

    const _payload = data;

    delete _payload.disclaimers;

    try {
      await updateShipmentUnLoading({ ..._payload },).unwrap();
      toast.success("Shipment unloading successfully updated!");
      navigate(`/app/crm/shipment-unLoading/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Shipment unloading!"
      );
    }
  };

  useAppMeta("Edit Shipment unloading");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingShipmentUnLoading || updatingShipmentUnLoading}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ShipmentUnLoadingForm
          isBusy={loadingShipmentUnLoading || loadingShipmentUnLoading}
          shipmentUnLoadingDetail={shipmentUnLoadingDetail}
          onSubmit={handleUpdateShipmentUnLoading}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default ShipmentUnLoadingEditScreen